module.exports = __webpack_public_path__ + "img/covid1.bd93d9c2.png";